import { useEffect } from "react";
import { useGetConfig } from "../store/use-config";
import { useRoutes } from "./use-routes";

export const useHandleGroupActionState = () => {
  const config = useGetConfig();
  const { goToFinishedAction, goToLimitReached, goToRunOutOfSlots } = useRoutes();

  useEffect(() => {
    if (config.isActionFinished) return goToFinishedAction();
    if (config.isPatientsLimitReached) return goToLimitReached();
    if (config.availableSlots && config.availableSlots.length === 0) return goToRunOutOfSlots();
  }, [config, goToFinishedAction, goToLimitReached, goToRunOutOfSlots]);
};
